import clsx from 'clsx';
import './line-items.css';
import { UseFormRegisterReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { DeleteIcon } from '../../assets/svg/DeleteIcon';
import { Button } from '../button';
import { AmountField, SelectField } from '../fields';
import { OptionType } from '../select/Select';

type FieldsProps = {
	amount: UseFormRegisterReturn & {
		acceptanceTestTargetId?: string;
	};
	select: UseFormRegisterReturn & {
		acceptanceTestTargetId?: string;
	};
};

export interface LineItemProps {
	itemKey: string;
	options: OptionType[];
	currencySymbol: string;
	fields?: FieldsProps;
	onClickRemove?: () => void;
	errorMessages?: Record<string, string>;
}
export const LineItem = (props: LineItemProps) => {
	const { t: translate } = useTranslation();

	const { itemKey, options, currencySymbol, fields, onClickRemove, errorMessages } = props;

	const { ref: selectRefCallback, ...selectFieldProps } = fields?.select || {};
	const { ref: amountRefCallback, ...amountFieldProps } = fields?.amount || {};

	const fieldsWithRefs = {
		select: {
			...selectFieldProps,
			ref: (e: HTMLSelectElement | null) => {
				if (selectRefCallback) {
					selectRefCallback(e);
				}
			},
		},
		amount: {
			...amountFieldProps,
			ref: (e: HTMLInputElement | null) => {
				if (amountRefCallback) {
					amountRefCallback(e);
				}
			},
		},
	};

	return (
		<div key={itemKey} className={clsx('line-item', 'brand-bg-highlight')}>
			<div className="line-item-input-container">
				<SelectField
					classes={{ label: 'line-item-label' }}
					errorMessage={errorMessages?.FundKeyOrName}
					id={`${itemKey}-split-fund-select-input`}
					invalid={!!errorMessages?.FundKeyOrName}
					options={options}
					required
					{...fieldsWithRefs?.select}
				/>
				<AmountField
					classes={{
						label: 'line-item-label',
					}}
					currencySymbol={currencySymbol}
					errorMessage={errorMessages?.Amount}
					id={`${itemKey}-split-fund-amount-input`}
					invalid={!!errorMessages?.Amount}
					required
					{...fieldsWithRefs?.amount}
				/>
			</div>
			<div>
				<Button
					className="line-item-remove-btn"
					label={
						<span className="line-item-remove-btn-span">
							<span className="line-item-remove-btn-icon">
								<DeleteIcon />
							</span>
							<span>{translate('lineItem.remove')}</span>
						</span>
					}
					variant="transparent"
					small
					onClick={onClickRemove}
				/>
			</div>
		</div>
	);
};
